<template>
  <div
    class="bb-technical-support"
    :class="[isFounder && 'bb-technical-support_founder']"
    @click="onOpenModal"
  >
    <span v-html="buildIcon"/>
    Technical support
  </div>
</template>

<script>
import {BuildIcon} from '@/constants/icon'

export default {
  name: 'TechnicalSupportButton',
  props: {
    isFounder: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    buildIcon: BuildIcon()
  }),
  methods: {
    onOpenModal () {
      this.$emit('onOpenModal')
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../sass/variables";

  .bb-technical-support {
    display: flex;
    align-items: center;
    grid-gap: 0 16px;
    height: 43px;
    margin: 24px 20px 0 20px;
    padding: 0 20px;
    border: 1px solid $color-white;
    border-radius: 4px;
    color: $color-white;
    font-size: 15px;
    line-height: 18px;
    font-weight: 600;
    cursor: pointer;

    &_founder {
      margin: 10px 20px 0 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/TechnicalSupport/TechnicalSupportButton/TechnicalSupportButton.vue